<template>
  <app-dialer-main-page
    :avatar="avatar"
    :agent="agent"
    :contact="contact"
    :identifier="identifier"
    :description="description"
    :members="members"
    :timestamp="timestamp"
    :session-id="sessionId"
    :is-connecting="isConnecting"
    :is-in-progress="isInProgress"
    :is-on-hold="isContactOnHold"
    :is-muted="isAgentMuted"
    :is-put-on-hold-action-loading="isPutOnHoldActionLoading"
    :is-hang-up-action-loading="isHangUpActionLoading"
    :has-keypad-button="hasKeypadButton"
    :has-invite-button="hasInviteButton"
    :has-transfer-button="hasTransferButton"
    :has-mute-button="hasMuteButton"
    :has-hold-button="hasHoldButton"
    @toggle-keypad="$emit('toggle-keypad')"
    @toggle-members-page="$emit('toggle-members-page')"
    @toggle-invite-page="$emit('toggle-invite-page')"
    @toggle-transfer-page="$emit('toggle-transfer-page')"
    @put-on-hold="onTogglePutOnHold"
    @mute-self="onToggleMuteSelf"
    @hang-up="onHangUp"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import AppDialerMainPage from '../../components/pages/AppDialerMainPage.vue';
import {
  useCommonProps,
  useDialerStore,
  useDialerActions,
  useConferenceMembersActions,
} from '../../composables';

export default defineComponent({
  name: 'AppDialerMainPageContainer',
  components: {
    AppDialerMainPage,
  },
  emits: [
    'toggle-keypad',
    'toggle-members-page',
    'toggle-invite-page',
    'toggle-transfer-page',
  ],
  setup() {
    const { avatar } = useCommonProps();
    const {
      identifier,
      description,
      isInProgress,
      isAgentMuted,
      isContactOnHold,
      isPutOnHoldActionLoading,
      isHangUpActionLoading,
      sessionId,
      agent,
      contact,
      timestamp,
      members,
      isConnecting,
      hasKeypadButton,
      hasInviteButton,
      hasTransferButton,
      hasMuteButton,
      hasHoldButton,
    } = useDialerStore();
    const {
      onToggleMuteSelf,
      onTogglePutOnHold,
      onHangUp,
    } = useDialerActions();
    const { getConferenceMembers } = useConferenceMembersActions();

    return {
      avatar,
      agent,
      contact,
      identifier,
      description,
      members,
      timestamp,
      sessionId,
      isConnecting,
      isInProgress,
      isAgentMuted,
      isContactOnHold,
      isPutOnHoldActionLoading,
      isHangUpActionLoading,
      hasKeypadButton,
      hasInviteButton,
      hasTransferButton,
      hasMuteButton,
      hasHoldButton,
      getConferenceMembers,
      onToggleMuteSelf,
      onTogglePutOnHold,
      onHangUp,
    };
  },
  mounted() {
    this.getConferenceMembers();
  },
});
</script>
